// extracted by mini-css-extract-plugin
export default {"switchIcon":"ThemeSwitch_switchIcon__W07E0","DIcon":"ThemeSwitch_DIcon__S3xXV"};